// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"Modal_modal_wrapper__8ntO-","close_modal_button":"Modal_close_modal_button__LAwcX","modal_text":"Modal_modal_text__GDcbG"};